import { render } from "./check_circle.svg?vue&type=template&id=7a463b5d"
const script = {}
script.render = render

export default script